import { Component, computed, signal } from '@angular/core';
import { AuditLogModel } from '../../../shared/models/audit-log.model';
import {
  ButtonType,
  CardComponent,
  ColumnConfig,
  CustomAction,
  GenericModalComponent,
  GenericTableComponent,
  GlobalAction,
  ModalMode,
  ModalTabConfig,
  TableAction,
  TableActionConfig,
} from '@solcre-org/core-ui';
import { environment } from '../../../../environments/environment.local';
import { TranslateModule } from '@ngx-translate/core';
import { AuditLogChangeModel } from '../../../shared/models/audit-log-change.model';

@Component({
  selector: 'app-audit-log',
  imports: [GenericTableComponent, TranslateModule, GenericModalComponent],
  templateUrl: './audit-log.html',
})
export class AuditLog {
  endpoint = environment.API.AUDIT_LOG_URI;
  modalmodes = ModalMode;
  log = signal<AuditLogModel[]>([]);
  columns: ColumnConfig<AuditLogModel>[] = [
    {
      label: 'auditLog.timestamp',
      key: 'timestamp',
    },
    {
      label: 'auditLog.action',
      key: 'action',
    },
    {
      label: 'auditLog.entity',
      key: 'entity',
    },
    {
      label: 'auditLog.entityId',
      key: 'entityId',
    },
    {
      label: 'auditLog.user',
      key: 'user',
    },
  ];
  columnsLogs: ColumnConfig<AuditLogChangeModel>[] = [
    {
      key: 'field',
      label: 'auditLog.logField',
    },
    {
      key: 'oldValue',
      label: 'auditLog.logOldValue',
    },
    {
      key: 'newValue',
      label: 'auditLog.logNewValue',
    },
  ];

  modalFields = computed<ModalTabConfig<AuditLogModel>[]>(
    () => [] as any as ModalTabConfig<AuditLogModel>[]
  );
  globalActions: GlobalAction<AuditLogModel>[] = [];
  auditLogModalState = signal<boolean>(false);
  model = signal<AuditLogModel>(new AuditLogModel());

  customActions: CustomAction<AuditLogModel>[] = [
    {
      buttonConfig: {
        type: ButtonType.ICON,
        icon: 'fa-regular fa-eye',
      },
      isExtra: false,
      tooltipPosition: 'top',
      title: 'auditLog.showLog',
      callback: (row: AuditLogModel) => {
        this.model.set(row);
        this.auditLogModalState.set(true);
      },
    },
  ];

  auditLogModelFactory = (data: Partial<AuditLogModel>): AuditLogModel => {
    return new AuditLogModel().fromJSON(data);
  };

  onCloseModal(): void {
    this.auditLogModalState.set(false);
  }
}
